import axios from 'axios';

import {
  FETCH_USER_INFO,
  FETCH_USER_INFO_SUCCESS,
  FETCH_USER_INFO_ERROR,
  FETCH_USER_BALANCE_ERROR,
  START_RECEIVE_DATA,
  RECEIVE_DATA,
  UPDATE_MNP_STATUS_VISIBILITY,
  MNP_STATUS_VISIBILITY_KEY,
  OPEN_VALIDATION_PD_POPUP,
  CLOSE_VALIDATION_PD_POPUP,
  SUCCESS_VALIDATION_PD_REQUEST,
  FAIL_VALIDATION_PD_REQUEST,
  START_VALIDATION_PD_REQUEST,
  SET_ALLINONE_VALUE,
  ALLINONE_GET_REGION_ENDPOINT,
  ALLINONE_GET_STREET_ENDPOINT,
  ALLINONE_GET_HOUSE_ENDPOINT,
  ACCEPT_OFFER_ALLINONE_REQUEST_ENDPOINT,
  SET_PARTNERSHIP_TARIFF_STATUS,
  FETCH_FAMILY_DATA,
  FETCH_FAMILY_LOADING,
  FETCH_FAMILY_ERROR,
  OPEN_USIS_RESULT_POPUP,
  CLOSE_USIS_RESULT_POPUP,
  USIS_RESULT_POPUP_ENDPOINT,
  FETCH_USIS_RESULT_POPUP_DATA,
  SET_USIS_RESULT_STEP,
  FETCH_USER_TARIFFS_BLOCK,
  FETCH_USER_TARIFFS_BLOCK_ENDPOINT,
} from './constants';

function setMnpStatusVisibilityToSessionStorage(isHidden) {
  if (sessionStorage) {
    sessionStorage.setItem(MNP_STATUS_VISIBILITY_KEY, isHidden);
  }
}

function getMnpStatusVisibilityFromSessionStorage() {
  if (sessionStorage) {
    const isHidden = sessionStorage.getItem(MNP_STATUS_VISIBILITY_KEY);

    if (isHidden) {
      return JSON.parse(isHidden);
    }
  }

  return false;
}

export function updateMnpStatusVisibility(isHidden) {
  return {
    type: UPDATE_MNP_STATUS_VISIBILITY,
    data: isHidden,
  };
}

export function receiveData(data) {
  return {
    type: RECEIVE_DATA,
    data: Object.assign(
      data.balance ? { balanceTimestamp: new Date() } : {},
      data,
    ),
  };
}

export function fetchDataStart() {
  return {
    type: FETCH_USER_INFO,
  };
}

export function fetchDataSuccess(data) {
  return {
    data: Object.assign(
      data.balance ? { balanceTimestamp: new Date() } : {},
      data,
    ),
    type: FETCH_USER_INFO_SUCCESS,
  };
}

export function fetchDataError(error, requestType) {
  if (requestType === 'balance') {
    return {
      type: FETCH_USER_BALANCE_ERROR,
    };
  }

  return {
    error,
    type: FETCH_USER_INFO_ERROR,
  };
}

export function setPartnershipTariffStatus(isConnected) {
  return {
    type: SET_PARTNERSHIP_TARIFF_STATUS,
    payload: isConnected,
  };
}

export function fetchData(blocks, noTimeout = false, requestType) {
  return async (dispatch) => {
    dispatch(fetchDataStart());

    try {
      const { data } = await axios.get('/api/profile/userinfo/data/', {
        params: {
          noTimeout,
          blocks: blocks.toString(),
        },
      });

      dispatch(fetchDataSuccess(data));
    } catch (error) {
      dispatch(fetchDataError(error.message, requestType));
    }
  };
}

export function fetchInitialData(noTimeout) {
  return (dispatch, getState) => {
    const isMnpStatusHidden = getMnpStatusVisibilityFromSessionStorage();
    const { isPostpaid, isConvergent, isPorted } = getState().application;
    const blocks = [
      'BalanceNotification',
      'Status',
      'ProfileSummary',
      'Balance',
      'Accumulators',
      'Services',
      'AdditionalBalances',
      'InternetExtension',
      'SosService',
    ];

    if (isPostpaid) {
      blocks.push('GuaranteePayment');
    }

    if (isConvergent) {
      blocks.push('Convergence');
    }
    if (!isConvergent) {
      blocks.push('TariffServices');
    }

    // Feature Toggle для отключения Семьи старый функционал
    blocks.push('FamilyFeatureToggle');

    dispatch(fetchData(blocks, noTimeout));
    if (!isPorted) {
      dispatch(updateMnpStatusVisibility(isMnpStatusHidden));
    }
  };
}

export function fetchTariffServicesData(noTimeout) {
  return (dispatch) => {
    const blocks = [
      'BalanceNotification',
      'Status',
      'Balance',
      'Accumulators',
      'Services',
      'TariffServices',
    ];

    dispatch(fetchData(blocks, noTimeout));
  };
}

export function refetchData(blocks) {
  return (dispatch) => {
    dispatch(fetchData(blocks, true));
  };
}

export function fetchSasBalance() {
  return (dispatch) => {
    dispatch({ type: START_RECEIVE_DATA });

    axios.get('/api/profile/userinfo/bsas/')
      .then((response) => {
        dispatch(receiveData({
          sasBalance: {
            data: response.data,
            error: null,
            isLoading: false,
          },
        }));
      })
      .catch(() => {
        dispatch(receiveData({
          sasBalance: {
            data: null,
            error: true,
            isLoading: false,
          },
        }));
      });
  };
}

export const toggleBlockedCtnAction = (date, actionType) => () => axios.post(
  `/api/profile/userinfo/${actionType}/`,
  { dateStr: date },
)
  .then((response) => Promise.resolve(response.data))
  .catch((response) => Promise.reject(response.data));

export const cancelFutureStatusRequest = (requestType) => () => axios.post(
  '/api/profile/userinfo/cancelfuturerequest/',
  { requestType },
)
  .then((response) => Promise.resolve(response.data))
  .catch((response) => Promise.reject(response.data));

export function updateMnpStatusVisibilityForSession(isHidden) {
  return (dispatch) => {
    setMnpStatusVisibilityToSessionStorage(isHidden);

    dispatch(updateMnpStatusVisibility(isHidden));
  };
}

export function hideMnpStatusForSession() {
  return (dispatch) => {
    dispatch(updateMnpStatusVisibilityForSession(true));
  };
}

export const openValidationPDPopup = () => ({
  type: OPEN_VALIDATION_PD_POPUP,
});

export const closeValidationPDPopup = () => ({
  type: CLOSE_VALIDATION_PD_POPUP,
});

export const sendValidationPDFile = (file, url) => async (dispatch) => {
  dispatch({ type: START_VALIDATION_PD_REQUEST });
  try {
    const formData = new FormData();
    formData.append('name', file.name);
    formData.append('file', file);

    const { data } = await axios.post(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    if (data.IsSucceed) {
      dispatch({
        type: SUCCESS_VALIDATION_PD_REQUEST,
        payload: { text: data.Message },
      });
    } else {
      dispatch({ type: FAIL_VALIDATION_PD_REQUEST });
    }
  } catch (err) {
    dispatch({ type: FAIL_VALIDATION_PD_REQUEST });
  }
};

const houseNullPayload = {
  house: {},
  houses: [],
  flat: '',
  houseIsNotFound: false,
};

const streetNullPayload = {
  ...houseNullPayload,
  streets: [],
  street: {},
  streetIsNotFound: false,
};

const defaultPayload = {
  ...streetNullPayload,
  regions: [],
  region: {},
  regionIsNotFound: false,
  tariffNotFoundInRegion: false,
};

export const fetchRegions = (term) => (dispatch) => {
  const dispatchedObject = {
    type: SET_ALLINONE_VALUE,
    resetError: !term?.length >= 3,
    payload: {
      ...defaultPayload,
    },
  };
  if (!term?.length >= 3) {
    dispatch(dispatchedObject);
    return;
  }
  axios({
    url: ALLINONE_GET_REGION_ENDPOINT,
    method: 'get',
    params: {
      boldFont: false,
      startsWith: term,
      'ui-culture': 'ru-ru',
    },
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  })
    .then(({ data }) => {
      dispatchedObject.payload = {
        ...defaultPayload,
        regions: data.View.map((item) => ({
          label: item.Title.replace('<b>', '').replace('</b>', ''),
          id: item.DpcId,
        })),
      };
      dispatch(dispatchedObject);
    })
    .catch(() => {
      dispatchedObject.payload = {
        ...defaultPayload,
        tariffNotFoundInRegion: true,
        tariffNotFoundInRegionMessage:
          'Не удалось получить подсказку для регионов из-за ошибки на сервере',
      };
      dispatch(dispatchedObject);
    });
};

export const fetchStreets = (cityId, term) => (dispatch) => {
  axios({
    url: ALLINONE_GET_STREET_ENDPOINT,
    method: 'post',
    data: {
      cityId,
      term,
    },
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  }).then(({ data }) => {
    dispatch({
      type: SET_ALLINONE_VALUE,
      payload: {
        ...streetNullPayload,
        streets: data,
      },
    });
  });
};

export const fetchHouses = (streetId, term) => (dispatch) => {
  const dispatchedObject = {
    type: SET_ALLINONE_VALUE,
    resetError: !term,
    payload: {
      ...houseNullPayload,
    },
  };
  if (!term) {
    dispatch(dispatchedObject);
    return;
  }
  axios({
    url: ALLINONE_GET_HOUSE_ENDPOINT,
    method: 'post',
    data: {
      streetId,
      term,
    },
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  }).then(({ data }) => {
    dispatchedObject.payload = {
      houses: data,
      houseIsNotFound: false,
    };
    dispatch(dispatchedObject);
  });
};

export const sendRequiest = (form) => (dispatch) => {
  axios({
    url: ACCEPT_OFFER_ALLINONE_REQUEST_ENDPOINT,
    method: 'post',
    data: {
      ...form,
    },
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  })
    .then(({ data }) => {
      dispatch({
        type: SET_ALLINONE_VALUE,
        payload: {
          requestData: data,
        },
      });
      return data;
    })
    .catch(({ data }) => {
      dispatch({
        type: SET_ALLINONE_VALUE,
        payload: {
          requestData: data || {
            IsSucceeded: false,
            ErrorMessage:
              'Во время отправки заявки произошла ошибка. Мы уже работаем над её исправлением, '
              + 'приносим свои извинения. Пожалуйста, позвоните по номеру 8(800)700&nbsp8000 и мы примем вашу заявку.'
              + 'Звонок бесплатный.',
            Errors: {
              CreateRequestError: true,
            },
          },
        },
      });
    });
};

const fetchFamilyLoading = (boolean) => ({
  type: FETCH_FAMILY_LOADING,
  payload: boolean,
});

const FetchFamilyData = (data) => ({
  type: FETCH_FAMILY_DATA,
  payload: data,
});

const fetchFamilyError = () => ({
  type: FETCH_FAMILY_ERROR,
});

export const fetchFamilyData = () => (dispatch) => {
  dispatch(fetchFamilyLoading(true));
  axios.get('/customers/products/mobile/profile/seb/')
    .then((response) => {
      dispatch(FetchFamilyData(response.data));
      if (!response.data) {
        dispatch(fetchFamilyError());
      }
    })
    .catch((error) => {
      dispatch(fetchFamilyError());
      console.warn(Error(`ERROR: Ошибка в запросе seb - ${error}`));
    })
    .finally(() => dispatch(fetchFamilyLoading(false)));
};

export const setUsisResultStep = (step) => ({
  type: SET_USIS_RESULT_STEP,
  payload: step,
});

export const fetchUsisResultPopupData = () => (dispatch) => {
  axios.get(USIS_RESULT_POPUP_ENDPOINT)
    .then((response) => {
      dispatch({
        type: FETCH_USIS_RESULT_POPUP_DATA,
        payload: response.data,
      });
    })
    .catch((error) => {
      console.warn(Error(`ERROR: Ошибка в запросе - ${error}`));
    });
};

export const openUsisResultPopup = () => ({
  type: OPEN_USIS_RESULT_POPUP,
});

export const closeUsisResultPopup = () => ({
  type: CLOSE_USIS_RESULT_POPUP,
});

export const fetchTariffsBlockData = () => (dispatch, getState) => {
  const { isConvergent, isFttb, isSubConvergent } = getState().application;
  if (isConvergent || isFttb || isSubConvergent) {
    axios.get(FETCH_USER_TARIFFS_BLOCK_ENDPOINT)
      .then((response) => {
        dispatch({
          type: FETCH_USER_TARIFFS_BLOCK,
          payload: response.data,
        });
      })
      .catch((error) => {
        console.warn(Error(`ERROR: Ошибка в запросе - ${error}`));
      });
  }
};
